import PropTypes from 'prop-types'
import React from 'react';
import "./Sensor.scss";

function SensorItem({ sensor, active, onChoose, isViewed = false }) {
    console.log(sensor.type)
    return (
        <div className={`sensoritem-container ${active ? 'active' : ''}`} onClick={() => {
            if (onChoose) {
                onChoose(sensor)
            }
        }
        }>
            <div className={"sensoritem-circle"}>
                { sensor.img &&
                    <img src={sensor.img} alt={sensor.alt} width="70%" />
                }
            </div>
            <div className={`sensoritem-caption ${isViewed ? 'viewed': ''}`}>
                {sensor.type}
            </div>
        </div>
    );
}

export default SensorItem;

SensorItem.propTypes = {
  sensor: PropTypes.object.isRequired
}
